import type { AuditEntry, AuditListResult, AuditQuery } from "@pustak-lms/contracts";

export function auditClient(request: <T>(path: string, init?: RequestInit) => Promise<T>) {
  return {
    listAuditLogs(query: AuditQuery = {}) {
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(query)) if (value !== undefined && value !== "") params.set(key, String(value));
      return request<AuditListResult>(`/api/platform/audit${params.size ? `?${params}` : ""}`);
    },
    getAuditLog: (id: string) => request<AuditEntry>(`/api/platform/audit/${encodeURIComponent(id)}`)
  };
}
